import {
    GET_ACADEMIC_CYCLE_CONFIGS_FAIL,
    GET_ACADEMIC_CYCLE_CONFIGS_SUCCESS,
    ADD_ACADEMIC_CYCLE_CONFIG_SUCCESS,
    ADD_ACADEMIC_CYCLE_CONFIG_FAIL,
    UPDATE_ACADEMIC_CYCLE_CONFIG_SUCCESS,
    UPDATE_ACADEMIC_CYCLE_CONFIG_FAIL,
    DELETE_ACADEMIC_CYCLE_CONFIG_SUCCESS,
    DELETE_ACADEMIC_CYCLE_CONFIG_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    academicCycleConfigs: [],
    error: null,
    loading: true
};

const academicCycleConfigReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des departments
        case GET_ACADEMIC_CYCLE_CONFIGS_SUCCESS:
            return {
                ...state,
                academicCycleConfigs: action.payload, // tableau d'objets branch
                loading: false,
                error: null
            };

        case GET_ACADEMIC_CYCLE_CONFIGS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une department
        case ADD_ACADEMIC_CYCLE_CONFIG_SUCCESS:
            return {
                ...state,
                academicCycleConfigs: [action.payload, ...state.academicCycleConfigs], // ajoute au début du tableau
                error: null
            };

        case ADD_ACADEMIC_CYCLE_CONFIG_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une department
        case UPDATE_ACADEMIC_CYCLE_CONFIG_SUCCESS:
            return {
                ...state,
                academicCycleConfigs: state.academicCycleConfigs.map(academicCycleConfig =>
                    academicCycleConfig.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet branch
                        : academicCycleConfig
                ),
                error: null
            };

        case UPDATE_ACADEMIC_CYCLE_CONFIG_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une department
        case DELETE_ACADEMIC_CYCLE_CONFIG_SUCCESS:
            return {
                ...state,
                academicCycleConfigs: state.academicCycleConfigs.filter(
                    academicCycleConfig => academicCycleConfig.id !== action.payload
                ),
                error: null
            };


        case DELETE_ACADEMIC_CYCLE_CONFIG_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default academicCycleConfigReducer;
